<template>
    <v-container>
        <h1>Grades</h1>
        <div class="typography" v-if="this.$store.state.status === 'fetch_success'">
        <p>Select the course number below to enter grades for enrolled students.</p>
        <div class="table_wrapper">

            <div class="table_wrapper_inner" v-for="term in this.sortedRosters" v-bind:key="term.term_code">
                <h3>{{ term[0].term }}</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Course Number</th>
                            <th>Instructor</th>
                            <th>Credits</th>
                            <th>Grades</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="course in term" v-bind:key="course.course_id">
                            <td width="40%">{{ course.title }}</td>
                            <td width="15%">{{ course.course_id }}</td>
                            <td width="20%">{{ course.instructor }}</td>
                            <td width="10%">{{ course.credits }}</td>
                            <td width="15%" align="left" v-if="course.credits !== '0.00'">
                                <div v-if="course.grading_open === '1'">
                                    <router-link v-if="course.all_graded !== 'A'" :to="{ path: '/grades/'+course.term_code.replace('/', '*')+'-'+course.course_id }" class="secondary-button">Enter Grades</router-link>
                                    <router-link v-else :to="{ path: '/grades/'+course.term_code.replace('/', '*')+'-'+course.course_id }" class="post_featured_link"><span class="post_featured_label">View Final Grades</span></router-link>
                                </div>
                                <div v-else>
                                    <router-link v-if="course.all_graded" :to="{ path: '/grades/'+course.term_code.replace('/', '*')+'-'+course.course_id }" class="post_featured_link"><span class="post_featured_label">View Final Grades</span></router-link>
                                    <span v-else>Grading not yet open.</span>
                                </div>
                            </td>
                            <td width="15%" align="left" v-else>
                                Grading not required for zero-credit course sections.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- <div class="table_wrapper_inner">
                <table>
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Course Number</th>
                            <th>Meeting Times</th>
                            <th>Instructor</th>
                            <th>Credits</th>
                            <th>Grades</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="course in this.course_rosters" v-bind:key="course.id">
                            <td>{{ course.title }}</td>
                            <td><router-link :to="{ path: '/grades/'+course.course_id }">{{ course.course_id }}</router-link></td>
                            <td></td>
                            <td>{{ course.instructor }}</td>
                            <td>{{ course.credits }}</td>
                            <td><router-link :to="{ path: '/grades/'+course.course_id }" class="secondary-button">Enter Grades</router-link></td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
        </div>
        </div>
        <div v-else>
            <v-skeleton-loader
            class="mx-auto"
            type="table: table-thead, table-tbody"
            ></v-skeleton-loader>
        </div>
    </v-container>
</template>
<script>
export default {
    data: () => ({
        sortedRosters: []
    }),

    computed: {
        course_rosters: function() {
            return this.$store.getters.course_rosters
        }
    },

    mounted() {
        this.course_rosters
        let self = this
        this.$store.dispatch('fetchInstructorRoster')
        .then((resp) => {
                window.console.log("DEETS: "+resp)
                window.console.log(JSON.stringify(this.sortRoster(this.course_rosters, 'term_code')));
                self.sortedRosters = this.sortRoster(this.course_rosters, 'term_code')
        })
    },

    methods: {
        sortRoster: function(xs, key) {
            return xs.reduceRight(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        }
    }
}
</script>
